import { ERROR, SET_ACCOUNT_INFO } from '../ActionTypes';

const initialState = {
    firstName: '',
    lastName: '',
    isAdmin: false,
    partners: [],
    partnerids: [],
    permissions: [],
    error: '',
};

const authReduction = (state = initialState, action) => {
    switch (action.type) {
        case ERROR:
            return {
                ...state,
                error: action.payload,
            };
        case SET_ACCOUNT_INFO:
            const accountInfo = action.payload;
            const {
                roles,
                given_name,
                family_name,
                partners,
                partnerids,
                permissions,
            } = accountInfo.idTokenClaims;

            const admin = (roles || []).includes('Admin');
            const partner =
                (roles || []).includes('Partner') &&
                (partnerids || []).filter((val, index) => val !== 'NONE')
                    .length > 0;
            return {
                ...state,
                isAdmin: admin,
                isPartnerUser: partner,
                firstName: given_name,
                lastName: family_name,
                partners: partners || [],
                partnerids: partnerids || [],
                permissions: permissions || [],
            };
        default:
            return state;
    }
};

export default authReduction;
